import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from "@angular/forms";
import { formatTextWithNoDiacritics } from "./formatting-condition";

/**
 * Funcion para validar que no hayan condiciones de minuta duplicadas en el formulario
 * @param formArray Form Array en donde se seleccionan las condiciones
 * @returns Regresa el error o nulo
 */
export const NoDuplicateMinuteConditionsValidator: ValidatorFn = (
 formArray: AbstractControl   
): ValidationErrors | null => {
    if(!formArray || !formArray.value){
        return null;
    }
    const values = formArray.value.map((group: any) => formatTextWithNoDiacritics(group.selectedCondition?.name));
    const duplicatedIndex = new Set<number>();

    values.forEach((value, index) => {
        const formattedValue = formatTextWithNoDiacritics(value)
        if(formattedValue && values.indexOf(formattedValue) !== index){
            duplicatedIndex.add(values.indexOf(formattedValue));
            duplicatedIndex.add(index);
        }
    });

    formArray.value.forEach((_, index) => {
        const control = (formArray as FormArray).at(index).get('selectedCondition');
        if(duplicatedIndex.has(index)){
            control?.setErrors({duplicate: true});
        } else {
            if(control?.hasError('duplicate')){
                control?.setErrors(null);
            }
        }
    });

    return duplicatedIndex.size > 0 ? {duplicates: true } : null;
};